import 'focus-visible'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, connect } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import axios from 'axios'
import Routes from '../routes'
import Nav from '~components/Nav'
import Footer from '~components/Footer'
import Notices from '~components/Notices'
import ScrollToTop from '~components/helpers/ScrollToTop'
import { authenticate, setAccount, setSuspended } from '~redux/auth'
import { setSearchEnabled } from '~redux/site'
import { loadCart } from '~redux/shop'
import CookieConsent from 'react-cookie-consent'
import Message from './ui/Message'

const App = ({ isAuthenticated, searchEnabled, suspendStatus }) => {
  const [authChecked, setAuthChecked] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    checkAuth()
    dispatch(setSearchEnabled(searchEnabled ?? true))
  }, [])

  useEffect(() => {
    if (suspendStatus !== window.Panache?.suspendStatus) return
    dispatch(setSuspended())
  }, [suspendStatus])

  const checkAuth = async () => {
    try {
      await axios.get('/api/auth/check')
      const response = await axios.get('/api/account')
      dispatch(setAccount(response.data))
      dispatch(loadCart())
      dispatch(authenticate())
    } catch (e) {
      console.error(e)
    } finally {
      setAuthChecked(true)
    }
  }

  if (!authChecked) {
    return (
      <div className="py-12 bg-white">
        <div className="max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <p className="text-base font-semibold leading-6 tracking-wide text-indigo-600 uppercase">
              Loading
            </p>
            <h3 className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              This won&apos;t take long
            </h3>
          </div>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <ScrollToTop />
      <Notices />

      {isAuthenticated && <Nav />}

      <main role="main" className="flex-grow">
        {isAuthenticated && !searchEnabled && (
          <Message
            messageType="warning"
            messageText="Search functionality is currently disabled due to maintenance. Please check back after 12:00 GMT."
            messagePosition="top"
          />
        )}

        <Routes />
      </main>

      {isAuthenticated && <Footer />}

      <CookieConsent
        acceptOnScroll={false}
        location="bottom"
        buttonText="X"
        cookieName="panache_b2b_cookie_consent"
        style={{ background: '#060707', margin: 'auto', position: 'relative' }}
        buttonStyle={{ margin: '0px 15px', padding: 0, top: '-3.5px' }}
        expires={150}
      >
        Like most websites, Panache uses cookies to ensure you get the best experience. To accept cookies continue browsing as normal or view our privacy policy to find out more.
      </CookieConsent>
    </Router>
  )
}

App.propTypes = {
  isAuthenticated: PropTypes.bool,
  searchEnabled: PropTypes.bool,
  account: PropTypes.object,
  suspendStatus: PropTypes.string
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    searchEnabled: state.site?.searchEnabled,
    suspendStatus: state.auth.account?.stockist?.status,
    account: state.auth.account
  }
}

export default connect(mapStateToProps)(App)
